import { VariablesForm } from '@components/Variables/types'

export const getDefaultVariable = (): VariablesForm => {
  return {
    id: undefined,
    variables: [
      {
        id: undefined,
        title: '',
        valueType: null,
        variableType: null,
        internalId: '',
      },
    ],
  }
}
